<template>
  <b-card header="Add lock to Lockgroup">
    <div class="card">
      <b-row>
        <div class="alert alert-success" style="width: 100%; margin: 20px;">
          <ul class="fa-ul" style="margin-bottom: 0px;">
            <li>
              <i class="fa fa-info-circle fa-li"></i>
              <div v-if="lockgroups.length > 0">
              Please select lockgroup below.
              </div>
              <div v-if="lockgroups.length === 0">
              None available.
              </div>

            </li>
          </ul>
        </div>
      </b-row>
      <!-- loop begin -->
      <b-row>
      <div class="col-sm-6 col-md-2" v-for="i in lockgroups" :key="i.id" style="margin:10px;">
        <div class="card" style="height:100%;">
          <div class="card-body">

            <div class="h1 text-muted text-right mb-4">
              <b-button type="button" variant="primary" v-on:click="addLockGroupToLock(`${i.id}`)" style="margin-bottom:  10px;float:left;">
                <i class="fa fa-dot-circle-o"></i> Add
              </b-button>
              <i class="icon-layers"></i>
            </div>
            <div class="h4 mb-0">{{i.totalLocks}}
              <small class="text-muted text-uppercase font-weight-bold" style="font-size:9px;" v-if="i.totalLocks > 1">
                Keys
              </small>
              <small class="text-muted text-uppercase font-weight-bold" style="font-size:9px;" v-if="i.totalLocks < 2">
                Key
              </small>
            </div>
            <div class="progress progress-xs mt-3 mb-0">
              <div class="progress-bar bg-success" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <small class="text-muted text-uppercase font-weight-bold" style="position:absolute; bottom:20px;"><i class="icon-location-pin"></i> {{i.location.name}}</small><br/>
            <small class="text-muted text-uppercase font-weight-bold" style="position:absolute; bottom:0;"><i class="icon-layers"></i> {{i.name}}</small><br/>
          </div>
        </div>
      </div>
      </b-row>
      <!-- loop end -->
      <!-- used lockgroup -->
      <b-row>
        <div class="alert alert-success" style="width: 100%; margin: 20px;">
          <ul class="fa-ul" style="margin-bottom: 0px;">
            <li>
              <i class="fa fa-info-circle fa-li"></i>
              <div>
              Assigned lock group
              </div>
            </li>
          </ul>
        </div>
        <div class="col-sm-6 col-md-2" v-for="i in usedLockgroups" :key="i.id" style="margin:10px;">
          <div class="card" style="height:100%;">
            <div class="card-body">

              <div class="h1 text-muted text-right mb-4">
                <b-button type="button" variant="danger" v-b-modal="'modaldelete' + i.id" style="margin-bottom:  10px;float:left;">
                  <i class="fa fa-trash-o"></i> Remove
                </b-button>
                <b-modal :id="'modaldelete' + i.id" @ok="handleOk(i.id, $event.target)" centered>
                  <div class="modal-window">

                    <div class="alert alert-danger">
                      <ul class="fa-ul" style="margin-bottom: 0px;">
                        <li>
                          <i class="fa fa-info-circle fa-li"></i>
                          <p style="font-size:14px;text-align:left;">Are you sure you want to remove Lockgroup for current lock?</p>
                        </li>
                      </ul>
                    </div>

                	</div>
                </b-modal>
                <i class="icon-layers"></i>
              </div>
              <div class="h4 mb-0">{{i.totalLocks}}
                <small class="text-muted text-uppercase font-weight-bold" style="font-size:9px;" v-if="i.totalLocks > 1">
                  Keys
                </small>
                <small class="text-muted text-uppercase font-weight-bold" style="font-size:9px;" v-if="i.totalLocks < 2">
                  Key
                </small>
              </div>
              <div class="progress progress-xs mt-3 mb-0">
                <div class="progress-bar bg-success" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
              <small class="text-muted text-uppercase font-weight-bold" style="position:absolute; bottom:20px;"><i class="icon-location-pin"></i> {{i.location.name}}</small><br/>
              <small class="text-muted text-uppercase font-weight-bold" style="position:absolute; bottom:0;"><i class="icon-layers"></i> {{i.name}}</small><br/>
            </div>
          </div>
        </div>
      </b-row>
    </div>
  </b-card>
</template>

<script>
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API_ASSIGN_LOCK_TO_LOCKGROUP = BASE + '/api/lockGroupMappers/add'
const API_REMOVE_LOCK_TO_LOCKGROUP = BASE + '/api/lockGroupMappers/delete'
const API_LIST_LOCKGROUP = BASE + '/api/lockgroups/list'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken,
      'authorization': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getData (lockId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockId: lockId
  }
  let res = await postdata(API_LIST_LOCKGROUP, parameters)
  return res
}

export default {
  name: 'lockgroup-list-add-lock',
  props: ['locationName', 'locationId', 'nextItem'],
  data: () => {
    return {
      lockgroups: [],
      usedLockgroups: []
    }
  },
  mounted () {
    if (localStorage.getItem('token')) {
      getData(this.$route.params.lockId).then(response => {
        this.$data.lockgroups = response.lockGroups
        this.$data.usedLockgroups = response.usedLockgroups
      })
    }
  },
  methods: {
    addLockGroupToLock (lockGroupId) {
      let lockId = this.$route.params.lockId
      let parameters = {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        lockId: lockId,
        lockGroupId: lockGroupId,
        locationDetail: localStorage.removeItem('locationDetail')   

      }
      postdata(API_ASSIGN_LOCK_TO_LOCKGROUP, parameters)
        .then(data => {
          //update lockCount for lockGroup
          //get data from lcoal storage
          //add lockGroup Mapper to lockForlocation
          //update lockgroup to localLockList
          //update lockgroup to localLocationsList

          let locationId = localStorage.getItem('locationId')
          let localLocationsList = localStorage.getItem('localLocationsList')
          localLocationsList = JSON.parse(localLocationsList)
          let indexLocation = localLocationsList.findIndex(location => location.id == locationId)
          localLocationsList[indexLocation].lockgroups[localLocationsList[indexLocation].lockgroups.findIndex(lg => lg.id == lockGroupId)].locksCount++
          localStorage.setItem('localLocationsList', JSON.stringify(localLocationsList))

          let selectedLockGroup = localLocationsList[indexLocation].lockgroups[localLocationsList[indexLocation].lockgroups.findIndex(lg => lg.id == lockGroupId)]
          let newlockgroup = {id: data.id, deleteDate: null, ownerId: localStorage.getItem('ouid'), lockId: lockId, lockGroupId: selectedLockGroup.id, mappedLockGroup: selectedLockGroup}
          
          let localLocksList = localStorage.getItem('localLocksList')
          localLocksList = JSON.parse(localLocksList)
          let locationIndex = localLocksList.findIndex(loc => loc.id == lockId)
          localLocksList[locationIndex].lockGroups.push(newlockgroup)
          localStorage.setItem('localLocksList', JSON.stringify(localLocksList))
          
          getData(lockId).then(response => {
            this.$data.lockgroups = response.lockGroups
            this.$data.usedLockgroups = response.usedLockgroups
          })
          console.log(data)
        })
        .catch(error => {
          console.error(error)
        })
    },
    deleteLockFromLockgroup (lockGroupId) {
      let lockId = this.$route.params.lockId
      let parameters = {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        lockId: lockId,
        lockGroupId: lockGroupId,
        locationDetail: localStorage.removeItem('locationDetail')
      }

      postdata(API_REMOVE_LOCK_TO_LOCKGROUP, parameters)
        .then(data => {
          //delete data from local storage
          let locationId = localStorage.getItem('locationId')


          //update lock count for lock group
          //lockgroup mapper for lockFor Location

          let localLocationsList = localStorage.getItem('localLocationsList')
          localLocationsList = JSON.parse(localLocationsList)
          let indexLocation = localLocationsList.findIndex(location => location.id == locationId)
          let oldLocksCount = localLocationsList[indexLocation].lockgroups[localLocationsList[indexLocation].lockgroups.findIndex(lg => lg.id == lockGroupId)].locksCount
          localLocationsList[indexLocation].lockgroups[localLocationsList[indexLocation].lockgroups.findIndex(lg => lg.id == lockGroupId)].locksCount--
          localStorage.setItem('localLocationsList', JSON.stringify(localLocationsList))

          let selectedLockGroup = localLocationsList[indexLocation].lockgroups[localLocationsList[indexLocation].lockgroups.findIndex(lg => lg.id == lockGroupId)]
          let newlockgroup = {id: data.id, deleteDate: null, ownerId: localStorage.getItem('ouid'), lockId: lockId, lockGroupId: selectedLockGroup.id, mappedLockGroup: selectedLockGroup}
          
          //updated lockGroup to local Lock List
          let localLocksList = localStorage.getItem('localLocksList')
          localLocksList = JSON.parse(localLocksList)
          let locationIndex = localLocksList.findIndex(lock => lock.id == lockId)
          localLocksList[locationIndex].lockGroups.splice(localLocksList[locationIndex].lockGroups.findIndex(lg => lg.lockGroupId == lockGroupId), 1)
          localStorage.setItem('localLocksList', JSON.stringify(localLocksList))

          getData(lockId).then(response => {
            this.$data.lockgroups = response.lockGroups
            this.$data.usedLockgroups = response.usedLockgroups
          })
          console.log(data)
        })
        .catch(error => {
          console.error(error)
        })
    },
    handleOk (id, button) {
      this.deleteLockFromLockgroup(id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/LockgroupListAddLock.vue